import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';

import styles from './CloseSplitViewButton.css';

function CloseSplitViewButton({ onClick, show }) {
  return show && (
    <Button
      className={styles.closeSplitView}
      data-test-id="dmb-close-split-view"
      mode="map"
      onClick={onClick}
    >
      <Icon glyph={Icon.set.REMOVE} />
      <span className={styles.closeText}>{getMessage('close')}</span>
    </Button>
  )
}

CloseSplitViewButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  show: PropTypes.bool,
};

export default CloseSplitViewButton;
